import classNames from "classnames";
import { Control, Controller } from "react-hook-form";
import styles from "./device-info-row.module.scss";

type Props = {
  label: string;
  value: string | number;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control?: Control<any>;
};

export const DeviceInfoRow = ({ label, value, className, control }: Props) => {
  if (control) {
    return (
      <Controller
        control={control}
        name={"name"}
        render={({
          field: { onChange, onBlur, value },
          formState: { errors },
        }) => {
          const error = errors["name"]?.message as string;

          return (
            <div
              className={classNames(styles.deviceRow, styles.input, className)}
            >
              <span className={styles.label}>{label}</span>
              <input
                autoFocus
                className={styles.value}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
              />
              {error && <span className={styles.error}>{error}</span>}
            </div>
          );
        }}
      />
    );
  }

  return (
    <div className={classNames(styles.deviceRow, className)}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </div>
  );
};
